<template>
  <div class="body apply">
    <div class="wrap">
      <div
        class="apply-menu-wrap1"
        :style="[pageUrl === '/user/reg/select' ? { display: 'none' } : {}]"
      >
        <div class="top-menu">
          <h1>
            <img
              v-if="logo !== '' || logo !== 'null' || logo !== 'undefined'"
              :src="logo"
              alt="company logo"
              class="h-30px"
            />
            <div v-else alt="company logo" style="height: 40px" />
            <span v-if="mainTitle !== ''">{{ mainTitle }}</span>
            <span v-else>사내어학클래스</span>
          </h1>
          <!-- 모바일용 -->
          <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
            <img src="../assets/img/m_gnb_sub.png" alt="menu" />
          </a>
          <ul>
            <li :class="{ 'on-blue': pageType === 'reg' }">
              <a v-if="pageType === 'reg'">신청하기</a>
              <a v-else class="pointer" @click="moveReg()">신청하기</a>
            </li>
            <li :class="{ 'on-blue': pageType === 'list' }">
              <a class="pointer" @click="moveApplyList()">신청내역 확인</a>
            </li>
            <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
            <li>
              <a class="pointer" @click="logout()">Logout</a>
            </li>
          </ul>
        </div>
        <!-- 반응형 메뉴 -->
        <div class="dp-inblock-m m-top-menu" id="header-menu">
          <a href="#" class="close" id="header-close">
            <img src="../assets/img/menu_close.png" alt="" />
          </a>
          <ul class="clear">
            <li><a class="pointer" @click="moveReg()">신청하기</a></li>
            <li>
              <a class="pointer" @click="moveApplyList()">신청내역 확인</a>
            </li>
            <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
            <li><a class="pointer" @click="logout()">Logout</a></li>
          </ul>
        </div>
      </div>
      <div class="con">
        <div class="title">
          <h2>결제</h2>
          <p><br /></p>
        </div>
        <div>
          <div class="apply-fieldset">
            <div class="apply-program-wrap">
              <!-- <div class="apply-select-number">
                    선택한 과정 <span v-if="sessionData.classList" class="txt-red">({{subjectLength}})</span>
                    <button class="pointer" @click="moveSelectPage()">다시 선택하기</button>
                </div> -->
              <div class="apply-program-select">
                <ul>
                  <div
                    v-for="(classItem, idx) of sessionData.classList"
                    :key="idx"
                  >
                    <!-- 선택 했을 경우 -->
                    <li
                      class="program-select blue"
                      v-for="(item, index) of classItem.subjectList"
                      :key="index"
                    >
                      <div class="apply-program-unit">
                        <ul>
                          <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                          <li
                            class="unit-title blue"
                            data-toggle="modal"
                            data-target="#program-info"
                          >
                            <h4 class="pay-title" @click="openModal(item)">
                              {{ item.subjectName }}
                            </h4>
                            <!-- <img src="../../assets/img/close.png" class="pointer" alt="" @click="deleteClass(index)"> -->
                          </li>
                          <li>
                            <p>
                              <span
                                >언어
                                <b class="bold">{{ item.language }}</b></span
                              >
                            </p>
                            <p>
                              <span
                                >스케쥴
                                <b class="bold"
                                  >{{ item.subjectStartTime }} ~
                                  {{ item.subjectEndTime }}</b
                                ></span
                              >
                            </p>
                          </li>
                          <li>
                            <p>
                              <span
                                >교육비
                                <b class="bold"
                                  >{{ numberFormat(item.eduPrice) }}원</b
                                ></span
                              >
                            </p>
                            <p>
                              <span
                                >교재비
                                <b class="bold"
                                  >{{ numberFormat(item.bookPrice) }}원</b
                                ></span
                              >
                            </p>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>
            <div class="hq-table-row">
              <h3>신청자 정보</h3>
              <table>
                <colgroup>
                  <col width="30%" />
                  <col width="70%" />
                </colgroup>
                <tbody v-if="paymentData.user">
                  <!-- <tr v-for="(item, index) of paymentData.user" :key="index">
                            <th>{{item.item_name}}</th>
                            <td>{{item.value}}</td>
                        </tr> -->
                  <tr v-if="paymentData.user.name">
                    <th>이름</th>
                    <td>{{ paymentData.user.name }}</td>
                  </tr>
                  <tr v-if="paymentData.user.email">
                    <th>E-mail</th>
                    <td>{{ paymentData.user.email }}</td>
                  </tr>
                  <tr v-if="paymentData.user.mobile">
                    <th>휴대전화번호</th>
                    <td>{{ paymentData.user.mobile }}</td>
                  </tr>
                  <tr v-if="paymentData.user.number">
                    <th>사번</th>
                    <td>{{ paymentData.user.number }}</td>
                  </tr>
                  <tr v-if="paymentData.user.company">
                    <th>회사</th>
                    <td>{{ paymentData.user.company }}</td>
                  </tr>
                  <tr v-if="paymentData.user.position">
                    <th>직급</th>
                    <td>{{ paymentData.user.position }}</td>
                  </tr>
                  <tr v-if="paymentData.user.dept">
                    <th>부서</th>
                    <td>{{ paymentData.user.dept }}</td>
                  </tr>
                  <tr v-if="paymentData.user.point">
                    <th>공인시험점수</th>
                    <td>{{ paymentData.user.point }}</td>
                  </tr>
                  <tr v-if="paymentData.user.optionName1">
                    <th>{{ paymentData.user.optionName1 || "-" }}</th>
                    <td>{{ paymentData.user.optionContents1 || "-" }}</td>
                  </tr>
                  <tr v-if="paymentData.user.optionName2">
                    <th>{{ paymentData.user.optionName2 || "-" }}</th>
                    <td>{{ paymentData.user.optionContents2 || "-" }}</td>
                  </tr>
                  <tr v-if="paymentData.user.optionName3">
                    <th>{{ paymentData.user.optionName3 || "-" }}</th>
                    <td>{{ paymentData.user.optionContents3 || "-" }}</td>
                  </tr>
                  <tr v-if="paymentData.user.optionName4">
                    <th>{{ paymentData.user.optionName4 || "-" }}</th>
                    <td>{{ paymentData.user.optionContents4 || "-" }}</td>
                  </tr>
                  <tr v-if="paymentData.user.optionName5">
                    <th>{{ paymentData.user.optionName5 || "-" }}</th>
                    <td>{{ paymentData.user.optionContents5 || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="hq-table-row">
              <h3>결제 정보</h3>
              <table>
                <colgroup>
                  <col width="30%" />
                  <col width="70%" />
                </colgroup>
                <tbody v-if="paymentData.payment">
                  <tr>
                    <th>결제금액</th>
                    <td>
                      {{
                        numberFormat(
                          paymentData.payment.book_price +
                            paymentData.payment.edu_price
                        )
                      }}
                      원
                    </td>
                  </tr>
                  <tr>
                    <th>결제방법</th>
                    <td>
                      <label for="card" v-show="payment.pay_way === 'C'">
                        <input
                          type="radio"
                          v-model="payType"
                          name="payTypeC"
                          id=""
                          value="card"
                        />
                        <span class="txt-13px ml-05 mr-20">카드결제</span>
                      </label>
                      <label for="pay" v-show="payment.pay_way === 'A'">
                        <input
                          type="radio"
                          v-model="payType"
                          name="payTypeA"
                          id=""
                          value="trans"
                        />
                        <span class="txt-13px ml-05 mr-20"
                          >실시간 계좌이체</span
                        >
                      </label>
                      <label for="pay" v-show="payment.pay_way === 'D'">
                        <input
                          type="radio"
                          v-model="payType"
                          name="payTypeD"
                          id=""
                          value="card"
                        />
                        <span class="txt-13px ml-05 mr-20">카드결제</span>
                        <input
                          type="radio"
                          v-model="payType"
                          name="payTypeD"
                          id=""
                          value="trans"
                        />
                        <span class="txt-13px ml-05 mr-20"
                          >실시간 계좌이체</span
                        >
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="apply-agree-btn">
          <button type="button" @click="applyByTossPayments">결제하기</button>
        </div>
        <detail-process
          v-if="isDetailModalOpened"
          :parentData="parentData"
          @close="closeModal()"
        ></detail-process>
      </div>
    </div>
    <div class="footer-wrap">
      <div class="footer">
        <div class="contact">
          <b>Access Code & 문의</b>
          <button class="float-right" @click="openModal('qna')">
            1:1 문의하기
          </button>
        </div>
        <div class="manager-wrap">
          <p v-for="(item, index) of qaList" :key="index">{{ item }}</p>
        </div>
        <qna-modal v-if="isQnaModalOpened" @close="closeModal()"></qna-modal>
      </div>
    </div>
  </div>
</template>

<script>
import QnaModal from "@/components/qnaModal.vue";
import Vue from "vue";
import DetailProcess from "@/components/reg/select/detailModal.vue";
const EventBus = new Vue();

const IMPCODE_APPLY = "imp28895051"; // Carrotglobal Iamport 실제 IMP코드
const IMPCODE_TEST = "imp36837262"; // 테스트 imp코드

const PGCODE_TEST = "inicis"; // version 1.1.0부터 지원. TEST용
const PGCODE_F = "kicc.IM000066"; // 글로벌 면세
const PGCODE_T = "kicc.IM000065"; // 글로벌 과세

export default {
  components: {
    DetailProcess,
    QnaModal,
  },
  data: () => ({
    sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
    info: [], // 전 페이지에서 사용자 정보 입력된 데이터
    payWay: {}, // 지불 방법
    totalPayment: 0, // 결제 최종 금액
    payType: "card", // card: 카드결제, trans: 실시간 계좌이체
    merchantUid: "", // api 결제 승인났을때 고유 아이디 받음 (이 아이디로 iamport에 사용)
    orderId: "", // 주문 id
    impUid: "", // imp id
    isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
    parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
    mainIdx: "",

    payWayP: "C", // 지불 방법
    partialPay: "A", // 전체결제 A 부분결제 P
    pgCodeType: "inicis", // pg사 코드 타입(iamport전용)
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    subjectLength: 0,

    isQnaModalOpened: false, // 1:1 문의 팝업 on/off
    pageType: "reg",
    pageUrl: "",
    logo: "",
    mainTitle: "",
    qaAdminInfo: "",
    qaList: [],

    paymentData: {}, // 별도 결제를 위한 전체 데이터
    payment: {}, // 별도 결제를 위한 결제 데이터
    user: {}, // 별도 결제를 위한 유저 데이터
    tossPayment: null, // 토스 페이먼트 SDK 객체
    isLoading: false, // 결제 진행 중 여부
  }),

  mounted() {
    if (sessionStorage.getItem("logo")) {
      if (sessionStorage.getItem("logo") === "undefined") {
        this.logo = "";
      } else {
        this.logo = sessionStorage.getItem("logo");
      }
    } else {
      this.logo = "";
    }

    if (sessionStorage.getItem("mainTitle")) {
      this.mainTitle = sessionStorage.getItem("mainTitle");
    } else {
      this.mainTitle = "";
    }

    if (sessionStorage.getItem("qaAdminInfo")) {
      this.qaAdminInfo = sessionStorage.getItem("qaAdminInfo");
      // console.log('this.qaAdminInfo', this.qaAdminInfo)
      this.qaList = this.qaAdminInfo.split(",");
    } else {
      this.qaAdminInfo = "";
    }

    if (sessionStorage.getItem("customPayment")) {
      this.paymentData = JSON.parse(sessionStorage.getItem("customPayment"));
      this.payment = this.paymentData.payment;
      this.user = this.paymentData.user;

      // 수강자 등록인 경우 결제타입이 없으므로 따로 추가
      if (!this.payment.pay_way) {
        this.payment.pay_way = this.paymentData.payWay;
      }

      // 수강자 등록인 경우 부분결제타입이 없으므로 따로 추가
      if (!this.payment.partial_pay) {
        this.partialPay = this.paymentData.partialPay;
      }
    } else {
      this.$router.push("/user/applyList");
    }

    var idx = sessionStorage.getItem("mainIdx");
    this.mainIdx = sessionStorage.getItem("mainIdx");
    var params = {
      idx: idx,
    };

    // 결제정보 데이터 api (결제방식, 과세/면세구분)
    this.axios
      .get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`)
      .then((res) => {
        if (res.data.err === 0) {
          this.payWay = res.data.payWay;

          if (this.payWay.pay_way === "C") {
            this.payType = "card";
            this.payWayP = "C";
          } else if (this.payWay.pay_way === "A") {
            this.payType = "trans";
            this.payWayP = "A";
          }

          if (res.data.payWay.partial_pay) {
            this.partialPay = res.data.payWay.partial_pay;
          }
        } else {
          alert(res.data.result);
        }
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }

    // 토스 페이
    const script = document.createElement("script");
    script.src = "https://js.tosspayments.com/v2/standard";
    script.onload = this.initializePayment;
    document.head.appendChild(script);
  },

  methods: {
    // 토스 페이먼트 초기화
    initializePayment() {
      const isTest =
        location.href.includes("local") || location.href.includes("stage");

      const clientKey = isTest
        ? "test_ck_DLJOpm5QrlwjnDPbR1qdVPNdxbWn"
        : "live_ck_6BYq7GWPVv2qD0jeOkeGVNE5vbo1";

      const tossPayments = window.TossPayments(clientKey);
      const customerKey = "cust_" + Math.random().toString(36).slice(2);

      this.tossPayment = tossPayments.payment({ customerKey });
    },

    // 토스 페이먼트 클릭 이벤트 추적
    trackClickPayment() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_payment",
        product_id: this.payment.idx_itm_sugang_class,
        product_name: this.payment.subject_name,
        price: this.payment.book_price + this.payment.edu_price,
      });
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
    },

    // 선택한 클래스 삭제
    deleteClass(idx) {
      this.totalPayment -=
        this.sessionData.classList[0].subjectList[idx].eduPrice +
        this.sessionData.classList[0].subjectList[idx].bookPrice;
      this.sessionData.classList[0].subjectList.splice(idx, 1);
    },

    // 클래스선택 페이지로 이동
    moveSelectPage() {
      this.$router.push("/user/reg/select");
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
    },

    storeMobilePayData() {
      var params = {
        email: this.user.email,
        name: this.user.name,
        mobile: this.user.mobile,
        payStatus: "Y",
        partialPay: "Y",
        payWay: this.payWayP,
        type: "Y",
        programIdx: this.payment.idx_itm_sugang_program,
        // orderId: orderId,
        idxItmSugangPageMain: this.payment.idx_itm_sugang_page_main,
        classList: [
          {
            classIdx: this.payment.idx_itm_sugang_class,
            idxItmSugangPageMain: this.payment.idx_itm_sugang_page_main,
            idxItmSugangProgram: this.payment.idx_itm_sugang_program,
            subjectList: [
              {
                subjectIdx: this.payment.idx_itm_sugang_subject,
                subjectName: this.payment.subject_name,
              },
            ],
          },
        ],
      };

      if (this.payment.idx_itm_sugang_student_subject) {
        params["studentSubjectIdx"] =
          this.payment.idx_itm_sugang_student_subject;
      } else {
        params["studentSubjectIdx"] = -1;
      }

      localStorage.setItem("mobilePayData", JSON.stringify(params));
    },

    // 수강신청 하기
    async applyByTossPayments() {
      const self = this;

      if (this.payType === "card") {
        this.payWayP = "C";
      } else if (this.payType === "trans") {
        this.payWayP = "A";
      }

      // 사용자 정보 검증
      if (!this.user.name || !this.user.email) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      const totalPrice = this.payment.book_price + this.payment.edu_price;

      var params = [];
      var tempQuery = {
        bookPriceYN: "Y",
        idxItmSugangPageMain: this.payment.idx_itm_sugang_page_main,
        idxItmSugangSubject: this.payment.idx_itm_sugang_subject,
        name: this.user.name,
        email: this.user.email,
        payWay: this.payWayP,
        partialPay: "A",
        status: "N",
        price: totalPrice,
        subjectName: this.payment.subject_name,
        totalPrice: totalPrice,
      };

      params.push(tempQuery);

      // 모바일 데이터 localstorage에 저장
      if (window.innerWidth < 1024) {
        this.storeMobilePayData();
        sessionStorage.setItem("isMobileCustomPayment", true);
      }

      self.axios
        .post(self.axios.root + self.axios.port + "/pay/check", params)
        .then(async (res) => {
          if (res.data.err === 0) {
            if (this.isLoading) {
              return;
            }

            if (!this.tossPayment) {
              alert("결제 모듈이 초기화되지 않았습니다.");
              return;
            }

            this.trackClickPayment();

            sessionStorage.setItem(
              "paymentUserInfo",
              JSON.stringify(this.info)
            );

            self.merchantUid = res.data.merchantUid;

            // 토스 결제 시작
            this.isLoading = true;

            try {
              const isTaxFree = self.payWay.tax_type === "F";
              const payload = {
                method: "CARD",
                amount: {
                  currency: "KRW",
                  value: totalPrice,
                },
                orderId: self.merchantUid,
                orderName: self.payment.subject_name,
                successUrl: `${window.location.origin}/paymentRedirect`,
                failUrl: `${window.location.origin}/user/customPayment`,
                customerName: self.user.name,
                customerEmail: self.user.email,
                card: { useEscrow: false },
              };

              if (isTaxFree) {
                payload.taxFreeAmount = totalPrice;
              }

              await this.tossPayment.requestPayment(payload);
            } catch (e) {
              sessionStorage.removeItem("paymentUserInfo");
              alert(e.message || "결제 요청에 실패했습니다.");
              this.isLoading = false;
            }
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },

    // 클래스 상세보기 레이어팝업 열기
    openModal(data) {
      this.parentData = data;
      this.isDetailModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isDetailModalOpened = false;
    },

    //  URL에 따라서 GNB 각 우측 버튼 활성화
    showProgress(path) {
      if (path) {
        this.pageUrl = path;
        if (path.includes("user/reg")) {
          this.pageType = "reg";
        } else if (path.includes("user/applyList")) {
          this.pageType = "list";
        }
      } else {
        this.pageUrl = this.$route.path;
      }
    },

    logout() {
      // 웹취약점
      this.axios
        .get(this.axios.root + this.axios.port + "/login/out")
        .then((res) => {
          if (res.data.err === 0) {
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");
            delete this.axios.defaults.headers.common["accessToken"];
            alert("로그아웃 되었습니다.");
            this.$router.push("/user/login");
          }
        });
    },

    // 모달 열기
    openModal(type) {
      if (type === "qna") {
        this.isQnaModalOpened = true;
      }
    },

    // 모달 닫기
    closeModal() {
      if (this.isQnaModalOpened) {
        this.isQnaModalOpened = false;
      }
    },

    // 수강 신청하기 시작
    moveReg() {
      this.$router.push("/user/reg/init");
    },

    // // 비밀번호 재설정 페이지로 이동
    // moveFixPW() {
    //     this.$router.push('/user/fixPW')
    // },

    // 신청내역 확인 페이지로 이동
    moveApplyList() {
      this.$router.push("/user/applyList");
    },
  },
};
</script>
